document.addEventListener("DOMContentLoaded", function () {
    let countdownContainer = document.getElementById("countdown-container");
    if (!countdownContainer) return;

    let targetDate = countdownContainer.getAttribute("data-date");
    if (!targetDate) return;
    if (targetDate.length === 10) { 
        targetDate += "T00:00:00";
    }

    let countDownDate = new Date(targetDate);
    countDownDate.setHours(23, 59, 59, 999); 

    function updateCountdown() {
        let now = new Date();
        let distance = countDownDate - now;

        let daysEl = document.querySelector("#countdown-days span:first-child");
        let hoursEl = document.querySelector("#countdown-hours span:first-child");
        let minutesEl = document.querySelector("#countdown-minutes span:first-child");
        let secondsEl = document.querySelector("#countdown-seconds span:first-child");
        //if (distance < 0) {
            //countdownContainer.innerHTML = "¡Ya disponible!";
            //return;
        //}
            if (distance < 0) {
            countdownContainer.innerHTML = "";
            let preorderSection = document.getElementById("preorder-section");
            if (preorderSection) preorderSection.style.display = "none"; 
            return;
        }

        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);

        daysEl.innerText = days.toString().padStart(2, '0');
        hoursEl.innerText = hours.toString().padStart(2, '0');
        minutesEl.innerText = minutes.toString().padStart(2, '0');
        secondsEl.innerText = seconds.toString().padStart(2, '0');
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
});
